import React from 'react';

import { Space } from 'antd-v5';
import { FormattedMessage } from 'react-intl';
import { Heading, Text } from 'scouting-ui/lib';

import Img from '@modules/shared/components/Img';

import BSALogo from '../../../../assets/images/BSAColorLogo.svg';
import { LineBreak } from '../LineBreak';
import { LoadingSpinnerInfo } from '../LoadingSpinnerInfo';

interface RequirementsHeaderProps {
  title: string | React.ReactNode;
  image?: string;
  name: string;
  isLoading?: boolean;
}

export function RequirementsHeader(props: RequirementsHeaderProps) {
  return (
    <div>
      <Heading font="display-h4" level={2}>
        {props.title}
      </Heading>
      <LineBreak />

      <Space align="center">
        {!props.image ? (
          <BSALogo width="60px" height="60px" />
        ) : (
          <Img width="60px" src={props.image} />
        )}
        <Text font="body-body-1">{props.name}</Text>
      </Space>

      <LoadingSpinnerInfo
        isLoading={!!props.isLoading}
        label={
          <FormattedMessage
            id="bulkEntry.spinners.fetchingRequirements"
            defaultMessage="Fetching requirements..."
          />
        }
      />
    </div>
  );
}
export default RequirementsHeader;
